import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { ValidateFreelanceView } from "../../views";
import { socket } from "../../../Context";
import { getNavigatorTimezone } from "../../../utils";
import { LocalStorageService, ProcedureUserService, WorkflowService, WorkflowMessagesService } from "../../../services";

class ValidateFreelanceAction extends Component {
  constructor(props) {
    super(props)
    this.state = {
      token: '',
      user: '',
      messageError: " ",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      showDocuments: true,
      showChat: true,
      showPdf: true,
      documents: [],
      usersChat: {},
      membersChat: [],
      conversation: [],
      urlDocument: "",
      showBtnBackStatus: false,
      showBtnNextStatus: true,
      nameBtnNext: '',
      backBtnName: '',
      statusValidated: [
        Number(process.env.REACT_APP_FREELANCE_STATUS_300520),
        Number(process.env.REACT_APP_FREELANCE_STATUS_300522),
        // Number(process.env.REACT_APP_FREELANCE_STATUS_300523),
        Number(process.env.REACT_APP_FREELANCE_STATUS_300525)
      ],
      subtitleOne: '',
      subtitleTwo: '',
      subtitleThree: '',
      subtitleFour: '',
      titleView: '',
      isLoadingView: false,
      cancelBtnName: '',
      showBtnCancelStatus: false,
      statusCancel: 0,
      varsOCR: [],
      showVars: false,
      documentSelected: {}
    }
  }

  token = {};
  url = process.env.REACT_APP_MIFIRMA_API;
  localStorageService = new LocalStorageService()
  procedureUserService = new ProcedureUserService(this.url)
  workflowService = new WorkflowService(this.url);
  workflowMessagesService = new WorkflowMessagesService(this.url);

  workflowExecutionId = 0
  timezone = getNavigatorTimezone()
  freelanceId = 0
  workflowFreelanceId = ''

  componentDidMount() {
    this.toggleLoadingView(true)
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    let urlArr = window.location.href.split('/')
    this.freelanceId = Number(urlArr[urlArr.length - 2])
    this.workflowExecutionId = urlArr[urlArr.length - 1]

    //call sockets    
    socket.on("messages", (data) => this.addNewMessageSocket(data));
    socket.emit("joinRoom", this.workflowExecutionId)

    this.getFreelanceData()
    this.getWorkflowExecution()
    this.getMessages()
    this.setState({
      token: this.token,
      user: this.user
    });
  }

  async componentWillUnmount() {
    socket.emit("leaveRoom", this.workflowExecutionId)
  }

  toggleLoadingView = (value) => {
    this.setState({
      isLoadingView: value
    })
  }

  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };

  toggleErrorRequesting = (message, time, sendInbox, path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.setState({
      showErrorRequesting: true,
      messageError: message
    }, () => {
      setTimeout(() => {
        this.setState({
          showErrorRequesting: false,
        })
        if (sendInbox) {
          this.props.history.push(sendTo)
        }
      }, time || 4000)
    })
  }

  toggleCompletedRequesting = (time, sendInbox, path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.setState({
      showCompletedRequesting: true,
    }, () => {
      setTimeout(() => {
        this.setState({
          showCompletedRequesting: false,
        })
        if (sendInbox) {
          this.props.history.push(sendTo);
        }
      }, time || 4000)
    })
  }

  getFreelanceData = async () => {
    let errorMessage = 'Ocurrió un error al consultar la información del usuario'

    try {
      let procedureUser = await this.procedureUserService.getProcedureUserData(this.freelanceId, this.token)
      if (procedureUser && procedureUser.data && Number(procedureUser.statusCode) === 200) {
        //Documents procedure user
        let documentsFree = []
        let documentsPromise = Promise.all(procedureUser.data.documents.map(async (documento, index) => {
          let document = {
            id: documento.id,
            clientDocumentId: documento.clientDocumentId,
            name: (documento.clientDocument.clientDocumentTypeRequestId === 2) ? `${documento.clientDocument.name}*` : documento.clientDocument.name,
            description: documento.clientDocument.description,
            userId: documento.userId,
            path: documento.pathDocument,
            dateToShow: (documento.documentWasLoaded) ? documento.updatedDateDoc : '',
            createdDate: documento.createdDateDoc,
            updatedDate: documento.updatedDateDoc,
            status: (documento.documentWasLoaded) ? this.props.t("contractingRegistrationDataView.grid.registeredThe") : this.props.t("contractingRegistrationDataView.grid.pending"),
            documentWasLoaded: documento.documentWasLoaded,
            clientDocumentTypeRequestId: documento.clientDocument.clientDocumentTypeRequestId,
            selected: (index === 0) ? true : false,
            valuesOCR: documento.valuesOCR,
            dataOCR: documento.dataOCR
          }
          documentsFree.push(document)
          return document
        }))

        await documentsPromise

        //Information procedure user
        let path = (documentsFree.length > 0 && documentsFree[0].path && documentsFree[0].path !== '') ? documentsFree[0].path : ''

        this.setState({
          subtitleOne: procedureUser.data.procedureUser.fullname,
          subtitleTwo: procedureUser.data.procedureUser.curp,
          subtitleThree: procedureUser.data.procedureUser.passportnumber,
          subtitleFour: (procedureUser.data.procedureUser.updatedDateUser) ? procedureUser.data.procedureUser.updatedDateUser : '',
          urlDocument: path,
          documents: documentsFree
        })
        this.toggleLoadingView(false)
      } else if (Number(procedureUser.statusCode) === -5) {
        errorMessage = 'No se encontro al usuario trámite en govo.legal'
        this.toggleLoadingView(false)
        this.toggleErrorRequesting(errorMessage, 4000, false, "/")
      } else if (Number(procedureUser.statusCode) === -6) {
        errorMessage = 'No se encontro el workflow del usuario trámite en govo.legal'
        this.toggleLoadingView(false)
        this.toggleErrorRequesting(errorMessage, 4000, false, "/")
      } else {
        this.toggleLoadingView(false)
        this.toggleErrorRequesting(errorMessage, 4000, false, "/")
      }
    } catch (error) {
      this.toggleLoadingView(false)
      this.toggleErrorRequesting(errorMessage, 4000, false, "/")
    }
  }

  async getWorkflowExecution() {
    let errorMessage = 'Ocurrió un error al consultar el workflow del contrato'

    try {
      let workflowExecution = await this.workflowService.getWorkFlowExecutionById(this.workflowExecutionId, this.token);
      if (workflowExecution && workflowExecution.data && Number(workflowExecution.statusCode) === 200) {
        let statusCurrent = workflowExecution.data.workflowStatusDescriptions.statusCurrent.status;
        let currenteName = workflowExecution.data.workflowStatusDescriptions.statusCurrent.name;
        let titleHeader = 'Validar usuario tramite'
        let statusIsEnable = this.state.statusValidated.includes(statusCurrent)
        let nameBtn = (workflowExecution.data.workflowStatusDescriptions && workflowExecution.data.workflowStatusDescriptions.statusNext && workflowExecution.data.workflowStatusDescriptions.statusNext.name) ? workflowExecution.data.workflowStatusDescriptions.statusNext.name : 'Validar usuario'
        let nameBackBtn = (workflowExecution.data.workflowStatusDescriptions && workflowExecution.data.workflowStatusDescriptions.statusBack && workflowExecution.data.workflowStatusDescriptions.statusBack.name) ? workflowExecution.data.workflowStatusDescriptions.statusBack.name : 'Regresar'

        //status cancel
        let cancelBtnName = (workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel && workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.label) ? workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.label : ''
        let statusCancel = (workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel && workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.status) ? workflowExecution.data.workflowStatusDescriptions.statusCurrent.statusCancel.status : ''
        let showBtnCancelStatus = (cancelBtnName && statusCancel) ? true : false

        //verify if user has permission
        let rolesMember = workflowExecution.data.workflowExecutionMembers.filter((member) => member.email === this.user.userMetaData.userA3Cloud.email)
        let userPermissionWorkflowArr = JSON.parse(workflowExecution.data.workflowStatus.membersTypeAllowToShow)
        let allPermission = rolesMember.map(role => {
          let permissionUser = userPermissionWorkflowArr.includes(role.workflowExecutionMemberTypeId)
          return permissionUser
        })

        let userHasPermission = allPermission.includes(true) ? true : false
        let statusNextBtn = workflowExecution.data.workflowStatusDescriptions.statusNext.status
        let statusBackBtn = workflowExecution.data.workflowStatusDescriptions.statusBack.status
        let showBtnNextStatus = (!statusIsEnable || !userHasPermission || statusNextBtn <= 0) ? false : true
        let showBtnBackStatus = (!statusIsEnable || !userHasPermission || statusBackBtn <= 0) ? false : true

        this.setState({
          workflow: workflowExecution.data,
          titleView: titleHeader,
          status: statusCurrent,
          showBtnNextStatus: showBtnNextStatus,
          showBtnBackStatus: showBtnBackStatus,
          nameBtnNext: nameBtn,
          backBtnName: nameBackBtn,
          userHasPermission,
          statusNextBtn,
          statusBackBtn,
          cancelBtnName,
          statusCancel,
          showBtnCancelStatus
        });
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(errorMessage, 4000, false, "/")
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(errorMessage, 4000, false, "/")
    }
  }

  getMessages = async () => {
    let errorMessages = "Ocurrió un error al consultar los mensajes";
    let user = {};
    try {
      //Get message and members chat
      let workflowMessage =
        await this.workflowMessagesService.getWorkFlowExecutionMessage(
          this.workflowExecutionId,
          this.timezone,
          this.token
        );
      if (
        workflowMessage &&
        workflowMessage.data &&
        Number(workflowMessage.statusCode) === 200
      ) {
        //Filter out duplicated members
        let membersChat = workflowMessage.data.workflowExecutionMembers.filter((member, index) =>
          workflowMessage.data.workflowExecutionMembers.findIndex((item) => item.email === member.email) === index
        );
        //users chat
        membersChat.map((member) => {
          member.id = member.workflowExecutionMemberId;
          member.avatarUrl = member.profilePicture;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarAltText = member.firstName + " " + member.firstLastName;
          if (this.user.userMetaData.userA3Cloud.email === member.email) {
            this.idAuthorMessage = member.id;
            user = member;
          }
          return membersChat;
        });

        //Message chat
        workflowMessage.data.workflowExecutionMessages.map((member) => {
          member.author = {
            name: member.firstName + " " + member.firstLastName,
            id: member.workflowExecutionMemberId,
            avatarUrl: member.profilePicture,
          };
          let dateConvert = new Date(member.createdDate)
          member.timestamp = dateConvert
          member.text = member.workflowExecutionMemberMessage;
          member.id = member.workflowExecutionMemberId;
          member.name = member.firstName + " " + member.firstLastName;
          member.avatarUrl = member.profilePicture;
          if (member.workflowExecutionMemberMessageDoc.length > 0) {
            member.attachments = [
              {
                name: member.workflowExecutionMemberMessageDoc[0]?.documentName,
                site: member.workflowExecutionMemberMessageDoc[0]?.documentPath,
              },
            ];
          }
          return workflowMessage.data.workflowExecutionMessages;
        });
        this.setState({
          membersChat: membersChat,
          conversation: workflowMessage.data.workflowExecutionMessages,
          usersChat: user,
        });
        this.toggleLoadingRequesting(false);
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(errorMessages, 4000, false, "/")
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(errorMessages, 4000, false, "/")
    }
  };

  createMessage = async (messagesChat, fileContent) => {
    let data = new FormData();
    data.append("workflowExecutionId", this.workflowExecutionId);
    data.append("workflowExecutionMemberId", this.idAuthorMessage);
    data.append("message", messagesChat.text);
    data.append("documento", fileContent);
    data.append("timezone", this.timezone)

    await this.workflowMessagesService.createWorkflowExecutionNewMessage(data, this.token);
  };

  markChatAsRead = async () => {
    try {
      await this.workflowMessagesService.markAsRead(this.workflowExecutionId, this.token)
    } catch (e) { }
  }

  addNewMessageSocket = (message) => {
    let copyConversation = [...this.state.conversation];
    let indexMessage = copyConversation.length;
    let newMessage = {
      author: {
        name: `${message.firstName} ${message.firstLastName}`,
        id: Number(message.workflowExecutionMemberId),
        avatarUrl: message.profilePicture,
      },
      timestamp: message.workflowExcecutionMemberMessage
        ? new Date(message.workflowExcecutionMemberMessage.createdDate)
        : new Date(
          message.workflowExecutionMemberMessageDocName[0].createdDate
        ),
      text: message.workflowExcecutionMemberMessage.message,
      id: Number(message.workflowExecutionMemberId),
      name: `${message.firstName} ${message.firstLastName}`,
      avatarUrl: message.profilePicture,
      workflowExecutionMemberId: Number(message.workflowExecutionMemberId),
      workflowExecutionMemberMessage:
        message.workflowExcecutionMemberMessage.message === "" ||
          message.workflowExcecutionMemberMessage.message === "undefined"
          ? null
          : message.workflowExcecutionMemberMessage.message,

      email: message.email,
      firstName: message.firstName,
      firstLastName: message.firstLastName,
      profilePicture: message.profilePicture,
      selectionIndex: indexMessage,
    };
    if (message.workflowExecutionMemberMessageDocName.length > 0) {
      newMessage.workflowExecutionMemberMessageDoc = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
      newMessage.attachments = [
        {
          name: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocName
            : "",
          site: message.workflowExecutionMemberMessageDocName
            ? message.workflowExecutionMemberMessageDocName[0]
              .workflowExecutionMemberMessageDocURL
            : "",
        },
      ];
    }

    copyConversation.push(newMessage);
    this.setState({
      conversation: copyConversation,
    });
  };

  handleInputChangeChat = (e) => {
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    this.setState({
      file
    })
  }

  handleBackBtn = (path) => {
    let sendTo = (path && path !== '') ? path : "/"
    this.props.history.push(sendTo)
  }

  handleWatchDoc = (document) => {
    let url = (document && document.path) ? document.path : ''
    let newDocs = [...this.state.documents]
    let varsOCR = (document && document.valuesOCR.length > 0) ? document.valuesOCR : []
    let showVars = (document && document.valuesOCR.length > 0) ? true : false

    newDocs = newDocs.map((documento) => {
      if (documento.id === document.id) {
        documento.selected = true
      } else {
        documento.selected = false
      }
      return documento
    })

    this.setState({
      documents: newDocs,
      urlDocument: url,
      varsOCR,
      showVars
    })
  }

  callWorkflowProcedureUser = async (e, action, statusDefined) => {
    this.toggleLoadingRequesting(true)
    let errorMessage = 'Ocurrió un error al cambiar el status del workflow'
    let documents = this.state.documents

    try {
      let workflow = await this.procedureUserService.callProcedureUserWorkflow(this.freelanceId, this.workflowExecutionId, action, statusDefined, this.token, documents)
      if (workflow && workflow.data && Number(workflow.statusCode) === 200) {
        this.toggleLoadingRequesting(false)
        this.toggleCompletedRequesting(4000, true, "/")
      } else if (Number(workflow.statusCode) === -5) {
        errorMessage = 'No se encontro al usuario trámite en govo.legal'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, errorMessage)
      } else if (Number(workflow.statusCode) === -6) {
        errorMessage = 'No se encontró el workflow relacionado al usuario'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, errorMessage)
      } else if (Number(workflow.statusCode) === -7) {
        errorMessage = 'No se encontro el status relacionado al worflow del usuario'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, errorMessage)
      } else if (Number(workflow.statusCode) === -8) {
        errorMessage = 'No ha terminado de cargar todos los documentos o información del usuario'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, errorMessage)
      } else if (Number(workflow.statusCode) === -9) {
        errorMessage = 'No se pudo actualizar al siguiente status el workflow'
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 4000, errorMessage)
      } else {
        this.toggleLoadingRequesting(false)
        this.toggleErrorRequesting(true, 400, errorMessage)
      }
    } catch (error) {
      this.toggleLoadingRequesting(false)
      this.toggleErrorRequesting(errorMessage, 4000, false, "/")
    }
  }

  handleWathcVars = (documento) => {
    let varsOCR = (documento.valuesOCR) ? documento.valuesOCR : []
    let copyDocs = [...this.state.documents]
    let newDocs = copyDocs.map((doc) => {
      if (doc.id === documento.id) doc.selected = true
      else doc.selected = false
      return doc
    })

    this.setState({
      showVars: true,
      varsOCR,
      documents: newDocs,
      documentSelected: documento
    })
  }

  handleChangeVars = (e, variable) => {
    let value = e.target.value
    let copyVars = [...this.state.varsOCR]
    let copyDocs = [...this.state.documents]

    let newVars = copyVars = copyVars.map((vari) => {
      if (vari.id === variable.id) variable.value = value
      return vari
    })

    let newDocs = copyDocs.map((doc) => {
      if (doc.id === this.state.documentSelected.id) {
        doc.valuesOCR = newVars
        doc.dataOCR.data = newVars
      }
      return doc
    })

    this.setState({
      varsOCR: newVars,
      documents: newDocs
    })
  }

  render() {
    return (
      <ValidateFreelanceView
        {...this.state}
        {...this.props}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        handleBackBtn={this.handleBackBtn}
        handleWatchDoc={this.handleWatchDoc}
        callWorkflowProcedureUser={this.callWorkflowProcedureUser}
        createMessage={this.createMessage}
        markChatAsRead={this.markChatAsRead}
        handleInputChangeChat={this.handleInputChangeChat}
        handleWathcVars={this.handleWathcVars}
        handleChangeVars={this.handleChangeVars}
      />
    )
  }
}

export default withTranslation()(ValidateFreelanceAction);
